import { Component } from "react";
import Toolbar from "../components/toolbar";
import exp from "constants";
import { dbAdmin } from "../../App";
import { addDoc, collection, deleteDoc, getDocs, updateDoc } from "firebase/firestore/lite";
import { MdAddBox } from "react-icons/md";
import { IoTrashOutline } from "react-icons/io5";
import { FaLock } from "react-icons/fa";
import { RiEdit2Line } from "react-icons/ri";
import { FaUnlockAlt } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { CgCloseO } from "react-icons/cg";
import { TiCancel,  } from "react-icons/ti";
import { ImCheckmark } from "react-icons/im";

class UserAccess extends Component<any,any> {

    constructor(props:any) {
        super(props);
        this.state = { users: [], user: {}, userdoc: {}}
    }

    async componentDidMount() {
        var userCol = collection(dbAdmin,'users');
        var userSnap = await getDocs(userCol);
        this.setState({users: userSnap.docs});
    }

    render () {
        return (
            <div style={{height: '100%', fontFamily: 'avenir'}}>
                <Toolbar />
                <section style={{marginLeft: '210px',height: '100%',display: 'flex',flexDirection:'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                    <div style={{width: '100%', fontFamily: 'avenirb', fontSize: '30pt'}}>
                        USER ACCESS
                    </div>
                    <div>
                        <div style={{fontFamily: 'avenirb'}}>Current Users</div>
                        Edit the users that can currently access this administration site.<br/><br/>
                        <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', cursor: 'pointer'}} onClick={()=>{
                            this.setState({updatingUser: true});
                        }}><MdAddBox style={{color: 'rgba(0,200,0,1)'}} size={30} /> NEW USER</div>
                        <br/>
                    </div>
                    <div style={{display: 'flex',borderBottom: '1px dotted #000'}}>
                        <div style={{width: '200px'}}><b>Username</b></div>
                        <div style={{width: '200px'}}><b>Password</b></div>
                        <div style={{width: '200px'}}><b>Enabled</b></div>
                        <div style={{width: '200px'}}></div>
                    </div>
                    {this.state.users.map((d:any, i:number)=>{
                        var u = d.data();
                        return(
                        <div key={i} style={{display: 'flex',marginTop: '10px',paddingBottom: '10px',borderBottom: '1px solid rgba(0,0,0,.2)'}}>
                            <div style={{width: '200px'}}>{u.username}</div>
                            <div style={{width: '200px'}}>****</div>
                            <div style={{width: '200px'}}>{u.active.toString().toUpperCase()}</div>
                            <div style={{width: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                
                                {u.active ? 
                                <FaUnlockAlt size={25} style={{marginRight: '30px', color: 'rgba(0,200,0,1)', cursor: 'pointer'}} onClick={async ()=>{
                                    var userCol = collection(dbAdmin,'users');
                                    await updateDoc(d.ref,{active: false});
                                    var userSnap = await getDocs(userCol);
                                    this.setState({users: userSnap.docs});

                                }}/>
                                : <FaLock size={25} style={{marginRight: '30px', cursor: 'pointer'}} onClick={async ()=>{
                                    var userCol = collection(dbAdmin,'users');
                                    await updateDoc(d.ref,{active: true});
                                    var userSnap = await getDocs(userCol);
                                    this.setState({users: userSnap.docs});
                                }}/>}
                                <FaEdit size={25} style={{marginRight: '30px', cursor: 'pointer'}} onClick={()=>{
                                    this.setState({updatingUser: true, user: u, userdoc: d});
                                }}/>
                                <FaTrash size={15} style={{marginRight: '30px', cursor: 'pointer', color: 'rgba(200,0,0,1)'}} onClick={async ()=>{
                                    var userCol = collection(dbAdmin,'users');
                                    await deleteDoc(d.ref);
                                    var userSnap = await getDocs(userCol);
                                    this.setState({users: userSnap.docs});
                                }}/>
                            </div>
                        </div>
                        )
                    })}
                    
                </section>
                {this.state.updatingUser ?
                <div className="overlay" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <div className="window">
                        <div className="closeWindow" onClick={()=>{
                            this.setState({updatingUser: false, user: {}, userdoc: {}});
                        }}>
                            <CgCloseO />
                        </div>
                        <div className="windowTitle">
                            ADD/EDIT USER
                        </div>
                        <div>
                            Add or update an existing user.  When finished, click the save button to confirm.
                        </div>
                        <div className="formStyle">
                            <div className="label">
                                Username
                            </div>
                            <div className="input">
                                <input type="text" required name="username" placeholder="ie. thatton" defaultValue={this.state.user.username} />
                            </div>
                            <div className="label">
                                Password
                            </div>
                            <div className="input">
                                <input type="password" required name="password" defaultValue={this.state.user.password} />
                            </div>
                            <div style={{marginTop: '10px'}}>
                                <input type="checkbox" name="enabled" defaultChecked={this.state.user.active} /> User access enabled.
                            </div>
                            
                        </div>
                        <div className="buttons">
                            <button className="cancelButton" onClick={()=>{
                                this.setState({updatingUser: false, user: {}, userdoc: {}});
                            }}><TiCancel /> CANCEL</button>
                            <button className="acceptButton" onClick={async ()=>{
                                 var userCol = collection(dbAdmin,'users');
                                if (this.state.user.username)
                                {
                                    // update user
                                    await updateDoc(this.state.userdoc.ref,{username: (document.getElementsByName("username")[0] as HTMLInputElement).value,
                                                            password: (document.getElementsByName("password")[0] as HTMLInputElement).value,
                                                            active: (document.getElementsByName("enabled")[0] as HTMLInputElement).checked
                                                            });
                                } else {
                                    // create new user
                                   
                                    await addDoc(userCol,{username: (document.getElementsByName("username")[0] as HTMLInputElement).value,
                                        password: (document.getElementsByName("password")[0] as HTMLInputElement).value,
                                        active: (document.getElementsByName("enabled")[0] as HTMLInputElement).checked
                                        });
                                }
                                var userSnap = await getDocs(userCol);
                    
                                this.setState({updatingUser: false, user: {}, userdoc: {},users: userSnap.docs});
                            }} ><ImCheckmark /> CONFIRM</button>
                        </div>
                    </div>
                </div>
                : null }
            </div>
        )
    }
}

export default UserAccess;